@if (event) {
  <div class="diary-item"
     [ngClass]="{
         'diary-item--cancelled' : event.isCancelled,
         'diary-item--selected' : isSelected,
         'diary-item--invite' : event.pendingInvite
    }"
    [ngbPopover]="onClick.observers.length > 0 ? null : popContent"
    placement="bottom"
    popoverClass="diary-popover"
    (click)="onClickItem()">
    <sb-alert [alertClass]="itemClass"
      customClasses="diary-item__inner"
      [rightIconName]="getIconName()"
      [rightIconOverlayName]="getStateIcon()"
      rightIconOverlayCustomClass="rounded"
      [rightLabel]="getCountLabel()"
      [rightIconTooltip]="getStateLabel()"
      [isBorderless]="isBorderless"
      [note]="getStateLabel()">
      <div class="diary-item__body">
        @if (event.personId) {
          <sb-avatar
            [personId]="event.personId"
            [fullName]="event.attendeeName"
            [photoUrl]="event.photoUrl"
            [showTooltip]="true"
          class="p-1"></sb-avatar>
        }
        <div>
          <div class="text-muted"
          [innerHTML]="timesLabel"></div>
          <div class="diary-item__title diary-item__truncate"
          [innerHTML]="event.title"></div>
          @if (!event.transportAttendee && event.eventType!=='Transport') {
            <div class="text-muted">
            {{event.ownerName}}</div>
          }
          @if (event.transportAttendee && event.personId) {
            <div class="diary-item__transport">
              <sb-icon name="transport-bus" overrideStyle="regular"></sb-icon>
              <span [innerHTML]="event.transportAttendee.stopName" class="mr-3 diary-item__truncate"></span>
            </div>
          }
          @if (!isDeclined()) {
            @if (event.consentDeadline && deadlineDifference) {
              @if (consentDeadlineExpired()) {
                <sb-text iconName="exclamationCircle" message="SB_Expired" customClasses="semi-bold" class="text-danger"></sb-text>
              } @else {
                <div [ngClass]="getDeadlineClass()">{{ deadlineDifference.days }} day {{ deadlineDifference.hours }} h {{ deadlineDifference.minutes }} min left</div>
              }
            }
            @if (event.emptySlots !== null && event.emptySlots !== undefined) {
              <div>
                <div [ngClass]="getEventSizeClass()">{{event.emptySlots}} places left</div>
                <ng-template #emptySlots></ng-template>
              </div>
            }
          }
          @if (isDeclined()) {
            <sb-text iconName="exclamationCircle" message="SB_Declined" customClasses="semi-bold" class="text-danger"></sb-text>
          }
        </div>
        <div class="diary-item__status ml-auto">
          @if (event.badgeClass && event.badgeMessage) {
            <sb-badge
              class="mr-2"
              [badgeClass]="event.badgeClass"
              [message]="event.badgeMessage"
              [customClasses]="'badge-square'"
            [allCaps]="true"></sb-badge>
          }
          @if (event.transportAttendee?.showViewChangeRequest && !event.transportAttendee?.hideProcessingStatus && !event.transportAttendee?.hasLinkedChangeRequest) {
            <sb-text class="mr-2"
              [textClass]="event.transportAttendee.statusClassName"
              [iconName]="event.transportAttendee.statusIcon"
              [message]="('SB_Change' | translate) + ': ' + (event.transportAttendee.statusLabel | translate)"
            ></sb-text>
          }
          @if (event.transportAttendee?.hasLinkedChangeRequest) {
            <sb-text class="mr-2"
              textClass="info"
              iconName="history"
              [tooltipText]="event.transportAttendee.parentReason"
              tooltipPlacement="bottom"
              message="SB_Changed"
            ></sb-text>
          }
        </div>
      </div>
    </sb-alert>
  </div>
}
<ng-template #popContent>
  <sb-diary-item-detail [event]="event"
    [stateClass]="getStateClass()"
    [stateIcon]="getStateIcon()"
  [stateLabel]="getStateLabel()"></sb-diary-item-detail>
</ng-template>
